import React from 'react';
import PropTypes from 'prop-types';

import {
  TELEHEALTH_YES,
  TELEHEALTH_NO,
  TELEHEALTH_UNSURE,
} from '../../../constants';
import MultiChoiceSelection from '../../components/MultiChoiceSelection';


const Telehealth = ({ value, onChange, setPagename, nextPage }) => {

  const choices = [
    TELEHEALTH_YES,
    TELEHEALTH_NO,
    TELEHEALTH_UNSURE,
  ];

  const handleGoNextPageOnClick = () => {
    setPagename(nextPage.name);
  };

  const handleOnChange = values => {
    onChange(values[0]);
  };

  return (
    <MultiChoiceSelection
      data={choices}
      selectedValues={value ? [value] : []}
      onChange={handleOnChange}
      isSingleChoice={true}
      handleSingleChoiceClick={handleGoNextPageOnClick}
    />
  );
};

Telehealth.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  setPagename: PropTypes.func,
  nextPage: PropTypes.object,
};

export default Telehealth;